// Centralized access to build-time environment variables.
//
// Vite inlines `import.meta.env.VITE_*` at build time. This module is the
// single source of truth so the rest of the app reads named constants instead
// of `import.meta.env` directly. The matching keys live in the .env files and
// CircleCI contexts; VITE_BUILD_ID is injected via `define` in vite.config.mjs.

export const API = import.meta.env.VITE_API
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT
export const VERSION = import.meta.env.VITE_VERSION
export const BUILD_ID = import.meta.env.VITE_BUILD_ID

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
export const LOGROCKET_APP_ID = import.meta.env.VITE_LOGROCKET_APP_ID

export const STREAM_CHAT_API_KEY = import.meta.env.VITE_STREAM_CHAT_API_KEY

export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
export const STRIPE_PRICING_TABLE_KEY = import.meta.env.VITE_STRIPE_PRICING_TABLE_KEY

export const RESOURCES_IMAGE_URL = import.meta.env.VITE_RESOURCES_IMAGE_URL

export const AUDIT_DEBUGGER_ACTIVE = import.meta.env.VITE_AUDIT_DEBUGGER_ACTIVE
